import React from "react";
import classes from "./ConfirmationPage.module.css";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { verifyOtp } from "../http/http";
import { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const ConfirmationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  const message = location?.state?.message || "Do you want to continue?";

const onConfirm = async () => {
  try {
    setLoading(true);

    const payload = {
      msisdn: location.state.mobile,
      otp: location.state.otp,
      pack: location.state.pack,
    };

    const response = await verifyOtp(payload);

    if (response.data.success) {
      toast.success("OTP verified successfully.");

      navigate("/home");
    } else {
      toast.error(response.data.message || "Invalid OTP");
    }
  } catch (error) {
    toast.error(error?.response?.data?.message || "Verification failed");
  } finally {
    setLoading(false);
  }
};

  const onCancel = () => {
    if (typeof location?.state?.onCancel === "function") {
      try { location.state.onCancel(); } catch (e) {}
    }
    if (location?.state?.onCancel === "stay") return;
    navigate(-1);
  };

  return (
    <main className={classes.main}>
      <img src="/images/moovafricalogo.png" alt="Moov Africa" className={classes.pageCornerLogo} />

      <motion.section
        className={classes.card}
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, ease: "easeOut" }}
      >
        <div className={classes.logoWrap}>
          <img src="/images/uv-gaming-logo.png" alt="UV Gaming" className={classes.logo} />
        </div>

        
        <h2 className={classes.title}>
  {t("123")}
</h2>
        <p className={classes.desc}> {message || t("124")}</p>

        <div className={classes.actions}>
 <button
  className={`${classes.btn} ${classes.yes}`}
  onClick={onConfirm}
  disabled={loading}
>
  {loading ? t("127") : t("125")}
</button>
          <button
  className={`${classes.btn} ${classes.no}`}
  onClick={onCancel}
>
  {t("126")}
</button>
        </div>
      </motion.section>
    </main>
  );
};

export default ConfirmationPage;